import React from 'react';
import { useOutletContext, Navigate, Outlet } from 'react-router-dom';

interface AppOutletContext {
  userData?: {
    role?: string;
    brokerDocId?: string | null;
  };
}

const BROKER_FAMILY_ROLES = ['broker', 'broker_assistant', 'credit_analyst'];

/**
 * Client Care access is DERIVED from the broker attachment, not a manual toggle:
 * a broker-family user reaches it only when attached to a broker (`brokerDocId`).
 * Admins / office-scoped roles are never restricted (mirrors RequireReportAccess).
 * The server `listClients.hasAccess` flag is the authoritative backstop; this
 * guard just keeps an unattached assistant/analyst (the extreme edge case) from
 * landing on an empty page via a stale link.
 */
const RequireClientCareAccess: React.FC = () => {
  const outletContext = useOutletContext<AppOutletContext>();
  const userData = outletContext?.userData;
  const role = userData?.role;

  if (role && BROKER_FAMILY_ROLES.includes(role) && !userData?.brokerDocId) {
    return <Navigate to="/" replace />;
  }
  return <Outlet context={outletContext} />;
};

export default RequireClientCareAccess;
